module.exports = __webpack_public_path__ + "static/sport/swiper-3.0e5ce0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/swiper-3.png
// module id = mWot
// module chunks = 0